import React from "react";

const FormSection = ({ children }) => {
  return <div className="forms-section">{children}</div>;
};

export default FormSection;
